import React from 'react';
import "../styles/index.css"
import card_video from "../img/chai-background.mp4"
import founders from "../img/founder.png"


const About = () => {

	return (

	<div>
		<video autoPlay loop muted className="card-video">
			<source src={card_video} type="video/mp4" />
		</video>

		<div className="outer-content">
    <div className="on-top">
      <div className="inside-div">
      <h2 className='topic-heading'>
                <b>About the Founders</b>
        </h2>
      <div className="main-content">

      

        <div className="card-left">
          <p className='upcoming-text medium-text'>
            <strong>Names</strong>:  Siddhi & Labdhi (we sisters) <br></br>
            <strong>Current Occupation</strong>: Students (Business & CS) <br></br>
            <strong>Why are we selling chai</strong>: In India, chai cultivates a sense of hospitality, belongingness, and emotion. Today, through technology, social norms, and fast-paced trends, society is losing the human touch to life. Our goal is to bring people together to enjoy the beauty of simple life starting with a pyaali of chai. <br></br>

          </p>	
        </div>

        <div className="card-right">
          <img className="medium-image" alt="founders_image" src={founders}></img>
        </div>
        
      </div>
      <h2 className='topic-heading'>
                <b>Pyaali in Chicago 2022</b>
        </h2>
      <p className='upcoming-text medium-text'>
        We started sampling our chai in Chicago Downtown 2 years ago.
        Your response surprised us! Y'all were so supportive of this idea, that at one point, we were selling 300+ cups of chai in only a few hours! You gave us all your love and support to get us to the next stage in our journey! 
      </p>
      <div class="tech-slideshow">
            <div class="mover-1"></div>
        </div>

     
      </div>
    </div>
     

			
		</div>
	</div>
		
	);
};

export default About;
